import { render, staticRenderFns } from "./contractInformationAdd.vue?vue&type=template&id=ddf1634e&scoped=true"
import script from "./contractInformationAdd.vue?vue&type=script&lang=js"
export * from "./contractInformationAdd.vue?vue&type=script&lang=js"
import style0 from "./contractInformationAdd.vue?vue&type=style&index=0&id=ddf1634e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf1634e",
  null
  
)

export default component.exports